import React, { useState } from "react"
import { ImageProps } from "./Image.types"
import SvgImg from "../../macro-component/ImageWrapper/SvgImg"

const ImageComponent = ({
  width,
  height,
  src,
  alt,
  loading = "lazy",
  className = "",
  testId = "shownImage",
  style = {},
  onClick = () => {},
  fullWidth = true,
}: ImageProps) => {
  const [showShimmer, setShowShimmer] = useState(false)

  return (
    <>
      <div className={`shimmering-image-container ${fullWidth ? "w-full" : ""} h-full`}>
        {/* Shimmer effect (overlay) */}
        {showShimmer && (
          <div data-testid="shimmer" className="animate-pulse">
            <div className={"bg-tertiary-light " + className}></div>
          </div>
        )}

        {/* Image */}
        <SvgImg
          src={src}
          alt={alt}
          width={width}
          height={height}
          loading={loading}
          // onError={() => {
          //   setShowShimmer(true)
          // }}
          // onLoad={() => {
          //   setShowShimmer(false)
          // }}
          className={className}
          style={{ display: showShimmer ? "none" : "block", ...style }}
          data-testid={testId}
          onClick={onClick}
        />
      </div>
    </>
  )
}

export default ImageComponent
